import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconHashtag20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconHashtag20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M9.242 3.106a.75.75 0 1 0-1.484-.212L7.25 6.45H4a.75.75 0 1 0 0 1.5h3.035l-.585 4.1H3a.75.75 0 0 0 0 1.5h3.235l-.477 3.344a.75.75 0 0 0 1.484.212l.508-3.556h3.485l-.477 3.344a.75.75 0 1 0 1.484.212l.508-3.556H16a.75.75 0 0 0 0-1.5h-3.035l.585-4.1H17a.75.75 0 0 0 0-1.5h-3.235l.477-3.344a.75.75 0 0 0-1.485-.212L12.25 6.45H8.766zM8.55 7.95l-.585 4.1h3.485l.585-4.1z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconHashtag20);
